import { create } from 'zustand';
import { ChecklistItem, mockNewMomChecklist, mockPreRetireeChecklist } from '@mocks/journeys';

interface ChecklistStore {
  items: Record<string, ChecklistItem[]>;
  toggleItem: (journeyType: string, itemId: string) => void;
  addItem: (journeyType: string, item: ChecklistItem) => void;
  deleteItem: (journeyType: string, itemId: string) => void;
  getItemsByJourney: (journeyType: string) => ChecklistItem[];
  initializeChecklist: (journeyType: string) => void;
}

export const useChecklistStore = create<ChecklistStore>((set, get) => ({
  items: {
    'new-mom': mockNewMomChecklist,
    'pre-retiree': mockPreRetireeChecklist,
  },

  toggleItem: (journeyType: string, itemId: string) => {
    set(state => ({
      items: {
        ...state.items,
        [journeyType]: state.items[journeyType]?.map(item =>
          item.id === itemId ? { ...item, completed: !item.completed } : item
        ),
      },
    }));
  },

  addItem: (journeyType: string, item: ChecklistItem) => {
    set(state => ({
      items: {
        ...state.items,
        [journeyType]: [...(state.items[journeyType] || []), item],
      },
    }));
  },

  deleteItem: (journeyType: string, itemId: string) => {
    set(state => ({
      items: {
        ...state.items,
        [journeyType]: state.items[journeyType]?.filter(item => item.id !== itemId),
      },
    }));
  },

  getItemsByJourney: (journeyType: string) => {
    const { items } = get();
    return items[journeyType] || [];
  },

  initializeChecklist: (journeyType: string) => {
    const { items } = get();
    if (!items[journeyType]) {
      set(state => ({
        items: {
          ...state.items,
          [journeyType]: [],
        },
      }));
    }
  },
}));
